import type { JSX } from 'react';

import { ColorBorderLight, ColorVariantsLight } from '@/constants/color';

import { Props, TopBar } from './types';

/**
 * @deprecated Do not use this component. Use the base components at the root of the UI folder instead.
 */
const Card = ({
  backgroundColorClassName,
  className,
  children,
  testId,
  topBar,
  paddingClass = 'p-3'
}: Props): JSX.Element => {
  const renderTopBar = (topBar: TopBar) => {
    if (topBar?.content) {
      const colorClasses = topBar?.bgColor
        ? `${ColorVariantsLight[topBar.bgColor]} ${ColorBorderLight[topBar.bgColor]}`
        : 'bg-white';
      return <div className={`${colorClasses} ${paddingClass} rounded-t-lg`}>{topBar.content}</div>;
    }
  };

  return (
    <div
      {...(testId ? { 'data-testid': testId } : {})}
      className={`group/section rounded-lg shadow mb-2 h-full relative ${className} ${
        backgroundColorClassName || 'bg-white'
      }`}>
      {topBar && renderTopBar(topBar)}
      <div className={paddingClass}>{children}</div>
    </div>
  );
};

export default Card;
